export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-pound-12a35f26fd1469c7b424c044ddecf5b0.svg";